import { Flex, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { DataTableColumn } from "mantine-datatable";

import ActionIcon from "../../../components/ActionIcon/ActionIcon.tsx";
import SvgAlert from "../../../components/Icons/Alert.tsx";
import SvgCheckCircle from "../../../components/Icons/CheckCircle.tsx";
import Table from "../../../components/Table/Table.tsx";
import { TableRow } from "../../../components/Table/types.ts";
import { PaymentStatus } from "../../../graphql/generated.ts";
import { TransactionHistory } from "../../../types/transactionHistory.ts";
import { toCurrencyPrice } from "../../../utils/number.ts";

interface Props {
  data: TransactionHistory;
}

export const InvoicesModal = ({ data }: Props) => {
  const [opened, { open, close }] = useDisclosure(false);

  const overdueInvoices = data.invoices.filter(
    (i) =>
      i.dpd &&
      i.dpd > 0 &&
      [PaymentStatus.NotPaid, PaymentStatus.Partial].includes(i.paymentStatus)
  );
  const hasOverdueInvoices = !!overdueInvoices.length;

  const columns: DataTableColumn<TableRow>[] = [
    {
      accessor: "invoiceNumber",
      title: "Invoice N0",
    },
    {
      accessor: "totalInvoice",
      title: "Total Invoice",
    },
    {
      accessor: "totalAmountDue",
      title: "OSP",
    },
    {
      accessor: "lateCharge",
      title: "Late Charge",
    },
    {
      accessor: "totalAccountReceivable",
      title: "Total AR",
    },
    {
      accessor: "totalPaid",
      title: "Total Paid Amount",
    },
    {
      accessor: "dpd",
      title: "DPD",
    },
  ];
  const rows = overdueInvoices.map((i) => ({
    invoiceNumber: i.invoiceNumber,
    totalInvoice: toCurrencyPrice(i.totalInvoice),
    totalAmountDue: toCurrencyPrice(i.totalAmountDue),
    lateCharge: toCurrencyPrice(i.lateCharge),
    totalAccountReceivable: toCurrencyPrice(i.totalAccountReceivable),
    totalPaid: toCurrencyPrice(i.totalPaid),
    dpd: i.dpd,
  }));

  return (
    <>
      {hasOverdueInvoices ? (
        <ActionIcon variant="error" onClick={open}>
          <SvgAlert />
        </ActionIcon>
      ) : (
        <ActionIcon variant="success" onClick={open}>
          <SvgCheckCircle />
        </ActionIcon>
      )}
      <Modal
        title="Overdue Invoices"
        size="auto"
        opened={opened}
        onClose={close}
      >
        <Flex direction="column" gap={8}>
          <Table
            minWidth="350px"
            columns={columns}
            rows={rows}
            verticalAlignment="top"
          />
        </Flex>
      </Modal>
    </>
  );
};
